export class PaymentService {
  constructor($http) {
    this.http = $http;
  }

  getUserPayments(userId, limit, page) {
    return this.http.get('/api/payment/user/' + userId + '/' + page + '/' + limit);
  }

  getPaymentsList(page, limit, query) {
    return this.http.post('/api/payment/list', {
      page: page,
      limit: limit,
      query: query
    });
  }

  getPaymentChart(options) {
    return this.http.post('/api/admin/payment/payment-chart', options);
  }

  getPaymentChartExport(options) {
    return this.http.post('/api/admin/payment/payment-chart/export', options);
  }

  createPayment(payment) {
    return this.http.post('/api/payment/create', payment);
  }

  updatePayment(payment){
    return this.http.post('/api/payment/update', payment);
  }

  removePayment(id) {
    return this.http.delete('/api/payment/' + id);
  }

  getPriceList(discount = false) {
    return this.http.get(`/api/price/list`);
  }

  initServipag(id, price, days) {
    return this.http.post('/api/payment/init-servipag', {id: id, days: days, price: price});
  }

  webpayInit(id, price, days) {
    return this.http.post('/api/payment/webpay/init', {id: id, price: price, days: days});
  }

  createPaypal() {
    return this.http.post(`/api/payment/paypal/create`);
  }

  stripeInit(price, days) {
    return this.http.post('/api/payment/stripe/init', {price: price, days: days});
  }

  sendRejectMessage() {
    return this.http.post('/api/payment/reject-message');
  }

  getPaymentCountByUsers(opt) {
    return this.http.post('/api/payment/payment-count', opt);
  }
}
